import { format } from 'date-fns';
import isSimpleDate from './isSimpleDate';
import adjustForTimeZone from './adjustForTimeZone';

/**
 * Returns a string representing the provided date with the required UI format.
 * If the second parameter is true, it will assume that the provided date string
 * is in timezone 0, and will apply the required adjustments according to the browser's
 * own timezone.
 *
 * @param sourceString - The date to be converted
 */
export default function dateFromServerString(
  sourceString: string,
  adjusted = true,
): string {
  try {
    if (!isSimpleDate(sourceString)) {
      let dateObject: Date;
      if (adjusted) {
        dateObject = adjustForTimeZone(sourceString);
      } else {
        dateObject = new Date(sourceString);
      }
      return format(dateObject, 'dd/MM/yyyy');
    }
    return sourceString;
  } catch (e) {
    return '';
  }
}
